import { ProjectUser } from "./v0-bm-project/project-user"

export class Team {
  admins: ProjectUser[] = []
  moa: ProjectUser[] = []
  be: ProjectUser[] = []
  architects: ProjectUser[] = []
  watchers: ProjectUser[] = []
}
